/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ComplianceRecommendation = {
  type: 'Enum',
} as const;
